import React from 'react'
import Header from './components/Header/Header'
import GlobalProviders from './app/GlobalProviders'
import AppRouter from './app/AppRouter'
import { useGlobalConfig } from './app/hooks'

function App() {
  // Use the global config hook for mouse event handling
  useGlobalConfig()

  return (
    <div>
      <GlobalProviders>
        <Header />
        <AppRouter />
      </GlobalProviders>
    </div>
  )
}

export default App
